export default __webpack_public_path__ + "static/media/successHabit.4168a7af.svg";